//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NotesItem from './components/changeNotesItem.vue';
export default {
    components: {
        NotesItem,
    },
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            uploadLists: []
        };
    },
    mounted() {


        this.getGlDetail(this.$route.query.id).then(response => {
            if (!this.$tools.getStorage('tag2')) {
                let tagList = response.data.tipTagsListModel.list;
                tagList.forEach((item, index) => {
                    item.id = index;
                    item.label = item.tagName;
                });
                this.$tools.setStorage('tag2', response.data.titleImageUrl);
            }
            if (!this.$tools.getStorage('img_url2')) {
                console.log(123);
                this.$tools.setStorage('img_url2', response.data.titleImageUrl);
            }
            this.uploadLists = [{ url: this.$tools.getStorage('img_url2') }];

            if (!this.$tools.getStorage('2gl1')) {
                this.$tools.setStorage('2gl1', response.data.title);
            }
            if (!this.$tools.getStorage('2gl2')) {
                this.$tools.setStorage('2gl2', response.data.subTitle);
            }
            if (!this.$tools.getStorage('2gl3')) {
                this.$tools.setStorage('2gl3', response.data.shareTitle);
            }
            if (!this.$tools.getStorage('zhaiyao2')) {
                this.$tools.setStorage('zhaiyao2', response.data.summary);
            }
            if (!this.$tools.getStorage('areaa2')) {
                this.$tools.setStorage('areaa2', response.data.regionName.replace(/[,]/g, '/'));
            }
            console.log(response, 'responseresponse');
            
            // if(!this.$tools.getStorage('glyj2')){
            //     this.$tools.setStorage('glyj2', JSON.stringify(response.data.tipCatalogListModel.list))
            // }
        });
        this.$tools.removeStorage('input');
        // console.log(this.$tools.getStorage('img_url'));
        // if(this.$tools.getStorage('img_url')){
        // this.uploadLists.push({url: this.PIC_BASE_URL + this.$tools.getStorage('img_url')})

        // }
    },
    methods: {
        getGlDetail(id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/wtcp-traveltips/tipSelf/getDetailTip?id=${id}&access_token=${this.userInfo ? this.userInfo.access_token : ''}`, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },


        handleDelete(file, detail) {
            this.uploadLists.splice(detail.index, 1);
            this.$tools.removeStorage('img_url2');
            this.$emit('deleteFile', file);
            return true;
        },
        beforeRead(file) {
            if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
                this.$toast('请上传 jpg/jpeg/png 格式图片');
                return false;
            }
            const isLt = file.size / 1024 / 1024 < 200;
            if (!isLt) {
                this.$toast('上传文件大小不能超过 200 MB!');
                return false;
            }
            return true;
        },
        upload(formData) {
            return new Promise((resolve, reject) => {
                this.$http.post('/api/zuul/wtcp-material/uploads/material/image', formData)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 上传
        async afterRead(file) {
            // let formData = new FormData();
            // formData.append('file', file.file);
            // // console.log(formData.getAll('file'))
            // // const postData = {
            // //       base64Code: file.content,
            // //       format: file.file.type.split("/")[1],
            // //     };
            // let result = await this.upload(file);
            // let img_Url = result.data[0].filePath;
            // this.$tools.setStorage('img_url2', img_Url);


            let formData = new FormData();
            formData.append('file', file.file);
            // 此时可以自行将文件上传至服务器
            let res = await this.upload(formData);
            let data = res.data;

            if (data) {
                let img_url = this.PIC_BASE_URL + data[0].filePath;
                this.uploadLists = [];
                this.uploadLists.push({ url: img_url })
                // this.formData.pic = data[0].filePath;
                this.$tools.setStorage('img_url2', img_url);
            }

            // 此时可以自行将文件上传至服务器
            // let res = await fileApi.uploadFile(formData)
            // if (res.code === 200) {
            // }
        },
        handleSave() {
            this.$dialog
                .confirm({
                    title: '提示',
                    message: '确认取消修改？'
                })
                .then(() => {
                    sessionStorage.clear();
                    this.$router.replace({
                        name: 'myStrategy'
                    });
                });
        },
        handleSubmit() {
            let tags = JSON.parse(this.$tools.getStorage('tag2'));
            let list = [];
            let obj = {};
            if (tags) {
                tags.forEach(item => {
                    obj = {};
                    obj.parentTag = null;
                    if (item.tagCatagory) {
                        obj.tagCatagory = item.tagCatagory;
                    } else {
                        obj.tagCatagory = item.id.substring(1);
                    }
                    obj.tagName = item.label;
                    list.push(obj);
                });
            }
            let strategyLists = JSON.parse(this.$tools.getStorage('glyj2'));
            let list2 = [];
            let obj2 = {};
            if (strategyLists) {
                strategyLists.forEach(item => {
                    obj2 = {};
                    obj2.link = null;
                    obj2.description = item.des;
                    obj2.sortNum = Number(item.sortNum);
                    obj2.title = item.name;
                    obj2.noteList = item.yjList;
                    list2.push(obj2);
                });
            }
            // console.log(list2);//所在区域

            const data = {
                author: 'admin',
                sortNum: 0,
                operationType: 125001001,
                tipSelfModel: { tipSelfId: JSON.parse(localStorage.getItem('userInfo')).username }
            };
            if (this.$tools.getStorage('glyj2')) {
                data.tipCatalogListModel = { list: list2 };
            }
            if (this.$tools.getStorage('tag2')) {
                data.tipTagsListModel = { list };
            }
            if (this.$tools.getStorage('zhaiyao2')) {
                data.summary = this.$tools.getStorage('zhaiyao2');
            }
            if (this.$tools.getStorage('img_url2')) {
                data.titleImageUrl = this.$tools.getStorage('img_url2');
            }
            if (this.$tools.getStorage('areaa2')) {
                data.regionName = this.$tools.getStorage('areaa2').replace(/[/]/g, ',');
            }
            if (this.$tools.getStorage('2gl1')) {
                data.title = this.$tools.getStorage('2gl1');
            }
            if (this.$tools.getStorage('2gl2')) {
                data.subTitle = this.$tools.getStorage('2gl2');
            }
            if (this.$tools.getStorage('2gl3')) {
                data.shareTitle = this.$tools.getStorage('2gl3');
            }
            console.log(data); //所在区域

            this.$dialog
                .confirm({
                    title: '提示',
                    message: '确认修改该攻略？'
                })
                .then(() => {
                    this.chageGl(this.$route.query.id, data).then(result => {
                        console.log(result);
                        if (result.msg == 'success') {
                            //  this.$tools.removeStorage('clearAll')
                            sessionStorage.clear();
                            this.$dialog
                                .alert({
                                    title: '提示',
                                    message: '修改成功！'
                                })
                                .then(() => {
                                    this.$router.push({
                                        name: 'myStrategy'
                                    });
                                });
                        }
                    });
                });
        },

        chageGl(id, data) {
            return new Promise((resolve, reject) => {
                this.$http
                    .put(`/api/wtcp-traveltips/tipSelf/${id}?access_token=${this.userInfo ? this.userInfo.access_token : ''}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }



    }
};
